module.exports = __webpack_public_path__ + "img/online2.d099335c.svg";